import { render } from "./FooterLayout.vue?vue&type=template&id=f5e9cc5e"
import script from "./FooterLayout.vue?vue&type=script&lang=js"
export * from "./FooterLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/azure-caf-pnp/azure-caf-pnp/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__